import { render, staticRenderFns } from "./GlobalEventForm.vue?vue&type=template&id=3056e30e&scoped=true&"
import script from "./GlobalEventForm.vue?vue&type=script&lang=js&"
export * from "./GlobalEventForm.vue?vue&type=script&lang=js&"
import style0 from "./GlobalEventForm.vue?vue&type=style&index=0&id=3056e30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056e30e",
  null
  
)

export default component.exports